import React from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  ListItemText
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      color: '#fff',
      textDecoration: 'none',
      '&:hover': {
        color: '#fff',
        textDecoration: 'underline'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '0.85rem',
      }
    },
    linkOuter: {
      flex: 1,
      textAlign: "center"
    },
    linkContainer: {
      flexDirection: 'row',
      display: 'flex',
      width: '100%',
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column'
      }
    }
  })
);

const footerLinks = [
  { text: 'Help & Support', href: 'https://www.zen.co.uk/help-support' },
  { text: 'Contact Us', href: 'https://www.zen.co.uk/contact-us' },
  { text: 'Cookies', href: 'https://www.zen.co.uk/cookie-policy' },
  { text: 'Privacy', href: 'https://www.zen.co.uk/privacy-notice' },
  { text: 'Accessibility', href: 'https://www.zen.co.uk/accessibility' },
];

const FooterLinks: React.FunctionComponent = () => {
  const classes = useStyles();

  return (
    <div className={classes.linkContainer}>
      {footerLinks.map((item: any) => {
        return (
          <ListItemText disableTypography className={classes.linkOuter} key={item.text}>
            <a
              className={classes.link}
              href={item.href}
              target="_blank"
              rel="noreferrer">
              {item.text}
            </a>
          </ListItemText>
        )
      })}
    </div>
  )
};

export default FooterLinks;